import React, {isValidElement} from 'react';
import {observable, action, computed, makeObservable} from 'mobx';
import {observer} from 'mobx-react';
import store from '../../s';
import ModalSimple from '../../../global/modal-simple';

@observer
class ModalInfo extends React.Component {
    constructor(props) {
        super(props);
        makeObservable(this);
    }

    @computed get PaymentName() {
        if (store.checkout.CheckoutType === ICheckoutType.paypal_express) {
            return 'PayPal';
        } else if (store.checkout.CheckoutType === ICheckoutType.stripe_express) {
            const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
            return isIOS ? 'Apple Pay' : 'Google/Web Pay';
        }
    }

    render() {
        return (
            <ModalSimple
                id="modal-shipping-paypal"
                title={`${this.PaymentName} Shipping Information`}
            >
                <div>
                    <p>We use your postal code and country to calculate shipping and tax, and to provide you with shipping options.</p>
                    <p>Once you select your shipping method, you'll continue to the payment section where you can apply a promo code or gift card.</p>
                    <p>
                        Then you'll login to {this.PaymentName}, where you can confirm or edit your {this.PaymentName} shipping address, and place your order.
                    </p>
                </div>
            </ModalSimple>
        );
    }
}
export default ModalInfo;
